<template>
  <main class="app-wrapper" :class="`${this.$route.meta.fullScreen ? 'h-full' : ''}`">
    <Header :class="window.width > 1280 ? switchHeaderClass() : ''"/>
    <Sidebar
        v-if="
        themeSettingsStore.menuLayout === 'vertical' &&
        themeSettingsStore.sidebarHidden === false &&
        window.width > 1280
      "
    />
    <Transition name="mobilemenu">
      <mobile-sidebar
          v-if="window.width < 1280 && themeSettingsStore.mobielSidebar"
      />
    </Transition>
    <Transition name="overlay-fade">
      <div
          v-if="window.width < 1280 && themeSettingsStore.mobielSidebar"
          class="overlay bg-slate-900 bg-opacity-70 backdrop-filter backdrop-blur-[3px] backdrop-brightness-10 fixed inset-0 z-[999]"
          @click="themeSettingsStore.mobielSidebar = false"
      ></div>
    </Transition>
    <div
        class="content-wrapper transition-all duration-150"
        :class="`${window.width > 1280 ? switchHeaderClass() : ''} ${this.$route.meta.fullScreen ? 'h-full' : ''}`"
    >
      <div
          :class="`page-content ${this.$route.meta.appheight ? 'h-full' : 'page-min-height'} ${this.$route.meta.fullWithHeader ? 'h-[calc(100vh-80px)] !p-4' : ''} ${this.$route.meta.fullScreen ? 'h-full lg:h-[100vh] !p-0 lg:!p-3' : ''}`"
      >
        <div
            :class="`transition-all duration-150 ${
            themeSettingsStore.cWidth === 'boxed'
              ? 'container mx-auto'
              : 'container-fluid'
          } ${
            this.$route.meta.fullScreen
              ? 'h-full'
              : ''
          } ${this.$route.meta.fullWithHeader ? 'h-full' : ''}`"
        >
          <Breadcrumbs v-if="!this.$route.meta.hide"/>
          <router-view v-slot="{ Component }">
            <transition :name="$route.meta.animation ? $route.meta.animation : 'router-animation'" mode="out-in" appear>
              <component :is="Component"></component>
            </transition>
          </router-view>
        </div>
      </div>
    </div>
<!--    <FooterMenu v-if="window.width < 768"/>-->
<!--    <Footer
        :class="window.width > 1280 ? switchHeaderClass() : ''"
        v-if="window.width > 768"
    />-->
  </main>
</template>
<script>
import Footer from "@/components/Footer/index.vue";
import Header from "@/components/Header/index.vue";
import window from "@/mixins/window";
import Sidebar from "@/components/Sidebar/index.vue";
import MobileSidebar from "@/components/Sidebar/MobileSidebar.vue";
import Breadcrumbs from "@/components/Breadcrumbs/index.vue";
import FooterMenu from "@/components/Footer/FooterMenu.vue";
import {useThemeSettingsStore} from "@/stores/themeSettings";

export default {
  mixins: [window],
  components: {
    Header,
    Footer,
    Sidebar,
    MobileSidebar,
    Breadcrumbs,
    FooterMenu
  },
  setup() {
    const themeSettingsStore = useThemeSettingsStore()

    function switchHeaderClass() {
      if (
          themeSettingsStore.menuLayout === "horizontal" ||
          themeSettingsStore.sidebarHidden
      ) {
        return "ltr:ml-0 rtl:mr-0";
      } else if (themeSettingsStore.sidebarCollasp) {
        return "ltr:ml-[72px] rtl:mr-[72px]";
      } else {
        return "ltr:ml-[248px] rtl:mr-[248px]";
      }
    }

    return {
      themeSettingsStore,
      switchHeaderClass
    }
  }
};
</script>
<style lang="scss">
.router-animation-enter-active {
  animation: coming 0.2s;
  animation-delay: 0.1s;
  opacity: 0;
}

.router-animation-leave-active {
  animation: going 0.2s;
}

@keyframes going {
  from {
    transform: translate3d(0, 0, 0) scale(1);
  }
  to {
    transform: translate3d(0, 4%, 0) scale(0.93);
    opacity: 0;
  }
}

@keyframes coming {
  from {
    transform: translate3d(0, 4%, 0) scale(0.93);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 1;
  }
}

@keyframes slideLeftTransition {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

.mobilemenu-enter-active {
  animation: slideLeftTransition 0.24s;
}

.mobilemenu-leave-active {
  animation: slideLeftTransition 0.24s reverse;
}

.page-content {
  @apply md:p-6 p-[15px];
}

.page-min-height {
  min-height: calc(var(--vh, 1vh) * 100 - 48px);
}


.singleUser-enter-active {
  animation: fade-in-right 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.singleUser-leave-active {
  animation: fade-in-right 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both reverse;
}

.singleUser-fa-enter-active {
  animation: fade-in-left 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.singleUser-fa-leave-active {
  animation: fade-in-left 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both reverse;
}

@-webkit-keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}


@-webkit-keyframes fade-in-left {
  0% {
    -webkit-transform: translateX(-50px);
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-in-left {
  0% {
    -webkit-transform: translateX(-50px);
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}


@-webkit-keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

.email_height {
  height: calc(var(--vh, 1vh) * 100 - 12.1rem);
}

@media (max-width: 768px) {
  .email_height {
    height: calc(var(--vh, 1vh) * 100 - 10.5rem);
  }
}
</style>
